var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.024,
    height: 22.018,
    viewBox: "0 0 22.024 22.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comment",
    d: "M25.564,20.848a10.889,10.889,0,1,0-4.716,4.718l4.69,1.172a.989.989,0,0,0,1.2-1.2Zm-2.012.109.865,3.461-3.461-.866a1,1,0,0,0-.723.1,8.915,8.915,0,1,1,3.417-3.417A.984.984,0,0,0,23.553,20.957Z",
    transform: "translate(-4.875 -4.875)",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.2d169ed941ab85c9a1a59c7bc6cf6c78.svg";
export { ForwardRef as ReactComponent };